import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

import { AppRoutingPathsEnum } from '@/shared/config/app-routing-paths.enum';
import { MainRoutingPathsEnum } from '@/shared/config/main-routing-paths.enum';
import { isDemoTariff, isSubscriptionActive } from '@/shared/models/tariff.model';
import { AuthService } from '@/shared/services/auth.service';
import { PaymentRequiredService } from '@/shared/services/payment-required.service';

export const paymentRequiredInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const auth = inject(AuthService);
  const paymentRequired = inject(PaymentRequiredService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === HttpStatusCode.PaymentRequired) {
        const tariff = auth.tariff$();
        if (tariff && isSubscriptionActive(tariff) && !isDemoTariff(tariff.code ?? null)) {
          // Действующий (по дате) платный тариф с исчерпанными запросами — допапакет.
          paymentRequired.show();
        } else {
          // Демо-лимит, подписка истекла по дате или тариф неизвестен — страница выбора тарифа.
          const subscriptionExpiredPath = `${AppRoutingPathsEnum.Desktop}/${MainRoutingPathsEnum.SubscriptionExpired}`;
          if (!router.url.startsWith(`/${subscriptionExpiredPath}`)) {
            void router.navigate([AppRoutingPathsEnum.Desktop, MainRoutingPathsEnum.SubscriptionExpired]);
          }
        }
      }

      return throwError(() => error);
    }),
  );
};
